module.exports = __webpack_public_path__ + "static/img/b2.9fc4c2de.png";